import { TagProps } from './types'

export function Tag({
  children,
  variant = 'dark',
  className = '',
  ...props
}: TagProps) {
  const variants = {
    dark: 'bg-lightning-yellow-950 text-white-50',
    yellow: 'bg-lightning-yellow-500 text-black-950',
  }

  return (
    <span
      className={`inline-flex min-h-7 items-center rounded-full px-5 py-1 font-sans text-sm font-normal leading-5 md:text-base ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </span>
  )
}
